import React from 'react';
import { Box, Typography, Button,  Paper, Grid2 } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import { useNavigate } from 'react-router-dom';

function DigitalJournal() {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#ffffff', fontFamily: 'Inter, sans-serif' }}>
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 },
                    py: 2.5
                }}>
                <Box sx={{ width: '100%', maxWidth: '960px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                     

                    {/* Main Content */}
                    <Box component="main" sx={{ flexGrow: 1 }}>
                        {/* Hero Section */}
                        <Box sx={{ py: { xs: 8, sm: 12 } }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column-reverse', md: 'row' },
                                    alignItems: 'center',
                                    gap: { xs: 4, md: 6 },
                                    px: 2,
                                    textAlign: { xs: 'center', md: 'left' }
                                }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 3, md: 4 }, flex: 1 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <Typography
                                            variant="h3"
                                            sx={{
                                                color: '#111827',
                                                fontSize: { xs: '2rem', sm: '3rem' },
                                                fontWeight: 900,
                                                letterSpacing: '-0.033em',
                                                lineHeight: 1.2
                                            }}>
                                            Your Private Digital Journal
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#4b5563',
                                                fontSize: { xs: '1rem', sm: '1.125rem' },
                                                fontWeight: 400
                                            }}>
                                            A simple, secure, and beautiful space to capture your thoughts, feelings, and memories.
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => { navigate("/early_access") }}
                                            sx={{
                                                minWidth: '84px',
                                                maxWidth: '480px',
                                                height: 48,
                                                px: 4,
                                                bgcolor: '#2574eb',
                                                color: 'white',
                                                textTransform: 'none',
                                                fontSize: '1rem',
                                                fontWeight: 'bold',
                                                letterSpacing: '0.015em',
                                                whiteSpace: 'nowrap',
                                                '&:hover': { bgcolor: '#1e5fc4' }
                                            }}>
                                            Request Early Access
                                        </Button>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        width: '100%',
                                        maxWidth: { xs: '280px', md: 'none' },
                                        aspectRatio: '1',
                                        backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuDpTciLX6_I4-TL1RkPQKY9CZdDy9HN3pccaxSWwV06lte3fApBG_fEDAkdihfBofXBnzibRuRfM9gW_7FgybBu3mqEkBdsTGuwjzFy4DxbVg4nxgcOKqXIWHw9sYmQzQp8_urV3sxI9BgKznMoyukVUOkhjVjdIPH2Gg74Ao4tN8qdhvdgrmOSifPXkAp1jZmjvR-X8VAOduOR3rkrS-0m6aMjR-6gWAU0Nd3HQ2dcQNXRPj_KIznHdqjboF8k8r6lSNkiletKLYoF")',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        borderRadius: '12px',
                                        md: { width: '100%' }
                                    }}></Box>
                            </Box>
                        </Box>

                        {/* Features Section */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5, px: 2, py: { xs: 8, sm: 12 } }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center', alignItems: 'center' }}>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        color: '#111827',
                                        fontSize: { xs: '2rem', sm: '2.25rem' },
                                        fontWeight: 900,
                                        letterSpacing: '-0.033em',
                                        maxWidth: '720px'
                                    }}>
                                    A sanctuary for your thoughts
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: '#4b5563',
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        maxWidth: '720px'
                                    }}>
                                    Discover a calm, private space designed to help you reflect and grow.
                                </Typography>
                            </Box>
                            <Grid2 container spacing={2} sx={{ width: '100%', display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' } }}>
                                <FeatureCard icon={<LockIcon sx={{ color: '#2574eb', fontSize: 24 }} />} title="Private & Secure" description="Your entries are encrypted and private to you. We respect your privacy." />
                                <FeatureCard icon={<AutoAwesomeIcon sx={{ color: '#2574eb', fontSize: 24 }} />} title="Beautifully Simple" description="A clean, distraction-free interface that puts your writing first." />
                                <FeatureCard icon={<ThumbsUpDownIcon sx={{ color: '#2574eb', fontSize: 24 }} />} title="Personal Growth" description="Reflect on your journey and track your personal development over time." />
                            </Grid2>
                        </Box>

                        {/* CTA Section */}
                        <Box
                            sx={{
                                bgcolor: '#f3f4f6',
                                borderRadius: '12px',
                                my: { xs: 8, sm: 12 },
                                mx: 2
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                    gap: { xs: 3, sm: 4 },
                                    px: { xs: 2, sm: 5 },
                                    py: { xs: 6, sm: 10 }
                                }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, textAlign: 'center', alignItems: 'center' }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            color: '#111827',
                                            fontSize: { xs: '2rem', sm: '2.25rem' },
                                            fontWeight: 900,
                                            letterSpacing: '-0.033em',
                                            maxWidth: '720px'
                                        }}>
                                        Ready to start your journey?
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#4b5563',
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            maxWidth: '720px'
                                        }}>
                                        Create your first entry today. It's free and takes less than a minute.
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Button
                                        variant="contained"
                                        onClick={() => { navigate("/early_access") }}
                                        sx={{
                                            minWidth: '84px',
                                            maxWidth: '480px',
                                            height: 48,
                                            px: 3,
                                            bgcolor: '#2574eb',
                                            color: 'white',
                                            textTransform: 'none',
                                            fontSize: '1rem',
                                            fontWeight: 'bold',
                                            letterSpacing: '0.015em',
                                            '&:hover': { bgcolor: '#1e5fc4' }
                                        }}>
                                        Request Early Access
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    {/* Footer */}

                </Box>
            </Box>
        </Box>
    );
}

function FeatureCard({ icon, title, description }) {
    return (
        <Grid2 xs={12} sm={6} md={4} sx={{ display: 'flex' }}>
            <Paper
                elevation={0}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    bgcolor: 'white',
                    p: 2,
                    height: '100%',
                    width: '100%'
                }}>
                <Box>{icon}</Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            color: '#111827',
                            fontSize: '1rem',
                            fontWeight: 'bold'
                        }}>
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#6b7280',
                            fontSize: '0.875rem',
                            fontWeight: 400
                        }}>
                        {description}
                    </Typography>
                </Box>
            </Paper>
        </Grid2>
    );
}

export default DigitalJournal;